<template>
  <div class="view-wrapper">
    <SearchBar placeholder="Search"/>
    <div class="wrapper">
      <IndexList ref="lal" :data="data" :title="title"></IndexList>
    </div>
  </div>
</template>

<script>
import IndexList from '@/components/index-list'
import WhiteSpace from '@/components/white-space'
import SearchBar from '@/components/search-bar'

export default {
  components: {
    WhiteSpace,
    IndexList,
    SearchBar
  },
  data () {
    return {
      title: '当前城市: 北京市',
      cityData: [
        {
          name: '★热门城市',
          cities: [
            {
              name: '北京市',
              tags: 'BEIJING,北京市',
              cityid: 1
            },
            {
              name: '上海市',
              tags: 'SHANGHAI,上海市',
              cityid: 2
            }
          ]
        },
        {
          name: 'A',
          cities: [
            {
              name: '鞍山市',
              tags: 'ANSHAN,鞍山市',
              cityid: 3
            },
            {
              name: '安庆市',
              tags: 'ANQING,安庆市',
              cityid: 4
            }
          ]
        },
        {
          name: 'B',
          cities: [
            {
              name: '北京市',
              tags: 'BEIJING,北京市',
              cityid: 1
            },
            {
              name: '巴音郭楞州',
              tags: 'BAYINGUOLENGZHOU,巴音郭楞州',
              cityid: 5
            },
            {
              name: '博尔塔拉州',
              tags: 'BOERTALAZHOU,博尔塔拉州',
              cityid: 6
            }
          ]
        },
        {
          name: 'C',
          cities: [
            {
              name: '成都市',
              tags: 'CHENGDU,成都市',
              cityid: 7
            }
          ]
        },
        {
          name: 'E',
          cities: [
            {
              name: '鄂尔多斯市',
              tags: 'EERDUOSI,鄂尔多斯市',
              cityid: 8
            },
            {
              name: '鄂州市',
              tags: 'EZHOU,鄂州市',
              cityid: 9
            },
            {
              name: '恩施州',
              tags: 'ENSHIZHOU,恩施州',
              cityid: 10
            }
          ]
        },
        {
          name: 'F',
          cities: [
            {
              name: '福州市',
              tags: 'FUZHOU,福州市',
              cityid: 11
            },
            {
              name: '佛山市',
              tags: 'FOSHAN,佛山市',
              cityid: 12
            },
            {
              name: '防城港市',
              tags: 'FANGCHENGGANG,防城港市',
              cityid: 13
            }
          ]
        },
        {
          name: 'G',
          cities: [
            {
              name: '广州市',
              tags: 'GUANGZHOU,广州市',
              cityid: 14
            },
            {
              name: '贵阳市',
              tags: 'GUIYANG,贵阳市',
              cityid: 15
            }
          ]
        },
        {
          name: 'H',
          cities: [
            {
              name: '杭州市',
              tags: 'HANGZHOU,杭州市',
              cityid: 16
            },
            {
              name: '和田地区',
              tags: 'HETIANDIQU,和田地区',
              cityid: 17
            }
          ]
        },
        {
          name: 'Z',
          cities: [
            {
              name: '郑州市',
              tags: 'ZHENGZHOU,郑州市',
              cityid: 18
            },
            {
              name: '张家口市',
              tags: 'ZHANGJIAKOU,张家口市',
              cityid: 19
            },
            {
              name: '张家界市',
              tags: 'ZHANGJIAJIE,张家界市',
              cityid: 20
            },
            {
              name: '珠海市',
              tags: 'ZHUHAI,珠海市',
              cityid: 21
            },
            {
              name: '中山市',
              tags: 'ZHONGSHAN,中山市',
              cityid: 22
            },
            {
              name: '自贡市',
              tags: 'ZIGONG,自贡市',
              cityid: 23
            },
            {
              name: '资阳市',
              tags: 'ZIYANG,资阳市',
              cityid: 24
            },
            {
              name: '枣庄市',
              tags: 'ZHAOZHUANG,枣庄市',
              cityid: 25
            },
            {
              name: '舟山',
              tags: 'ZHOUSHAN,舟山',
              cityid: 26
            },
            {
              name: '遵义市',
              tags: 'ZUNYI,遵义市',
              cityid: 27
            },
            {
              name: '淄博市',
              tags: 'ZIBO,淄博市',
              cityid: 28
            },
            {
              name: '株洲市',
              tags: 'ZHUZHOU,株洲市',
              cityid: 29
            },
            {
              name: '中卫市',
              tags: 'ZHONGWEI,中卫市',
              cityid: 30
            }
          ]
        }
      ]
    }
  },
  computed: {
    data () {
      let ret = []
      this.cityData.forEach(cityGroup => {
        let group = {}
        group.name = cityGroup.name
        group.items = []
        cityGroup.cities.forEach(city => {
          let item = {}
          item.name = city.name
          item.value = city.cityid
          group.items.push(item)
        })
        ret.push(group)
      })
      return ret
    }
  }
}
</script>

<style>
h3 {
  margin-left: 8px;
}
.item {
  background-color: #fff;
  border-bottom: 1px solid rgb(246, 246, 246);
  height: 60px;
  line-height: 60px;
  font-size: 18px;
  padding-left: 20px;
}
.wrapper {
    overflow: hidden;
    height: 100%;
    /* width: 95%; */
    margin: 0 auto
}
.view-wrapper {
    position: fixed;
    height: 100%;
    top: 45px;
    left: 0;
    bottom: 0;
    width: 100%
}
</style>






// WEBPACK FOOTER //
// src/pages/IndexList.vue